module.exports = __webpack_public_path__ + "static/media/video7.be967ea.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video7.mp4
// module id = tUjy
// module chunks = 1